document.addEventListener("DOMContentLoaded", function() {
  const infoButtons = document.querySelectorAll(".info-button");

  infoButtons.forEach(button => {
    const tooltip = button.querySelector(".info-tooltip");
    const closeIcon = tooltip.querySelector(".close-icon");
    const mediaQuery = window.matchMedia("(max-width: 989px)");

    function handleTooltip(event) {
      if (mediaQuery.matches) {
        event.stopPropagation();
        tooltip.style.display = tooltip.style.display === "flex" ? "none" : "flex";
      }
    }

    function closeTooltip(event) {
      if (mediaQuery.matches) {
        tooltip.style.display = "none";
        event.stopPropagation();
      }
    }
    
    button.addEventListener("click", handleTooltip);
    closeIcon.addEventListener("click", closeTooltip);

    document.addEventListener("click", (event) => {
      if (mediaQuery.matches && !button.contains(event.target)) {
        tooltip.style.display = "none";
      }
    });

    if (!mediaQuery.matches) {
      button.addEventListener("mouseenter", () => {
        tooltip.style.display = "flex";
      });

      button.addEventListener("mouseleave", () => {
        tooltip.style.display = "none";
      });
    }

    mediaQuery.addEventListener("change", () => {
      if (mediaQuery.matches) {
        button.removeEventListener("mouseenter", () => {
          tooltip.style.display = "flex";
        });
        button.removeEventListener("mouseleave", () => {
          tooltip.style.display = "none";
        });
      } else {
        button.removeEventListener("click", handleTooltip);
        closeIcon.removeEventListener("click", closeTooltip);
      }
    });
  });
});